var _circle, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgManageFaxesWithLabels(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#DDEEFE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 32.309V13h14v19.309l-6.518-3.585-.482-.265-.482.265L17 32.309z",
    stroke: "#329EFF",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 20h3m3 0h-3m0 0v-3m0 3v3",
    stroke: "#329EFF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMjQiIGN5PSIyNCIgcj0iMjQiIGZpbGw9IiNEREVFRkUiLz4KPHBhdGggZD0iTTE3IDMyLjMwODdWMTNIMzFWMzIuMzA4N0wyNC40ODE5IDI4LjcyMzhMMjQgMjguNDU4N0wyMy41MTgxIDI4LjcyMzhMMTcgMzIuMzA4N1oiIHN0cm9rZT0iIzMyOUVGRiIgc3Ryb2tlLXdpZHRoPSIyIi8+CjxwYXRoIGQ9Ik0yMSAyMEgyNE0yNyAyMEgyNE0yNCAyMFYxN00yNCAyMFYyMyIgc3Ryb2tlPSIjMzI5RUZGIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8L3N2Zz4K";
export { SvgManageFaxesWithLabels as ReactComponent };